/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Visitor } from '../../types/visitTypes';
import { UpdateVisitorPayload } from '../../types/visitorTypes';

export interface VisitorsState {
  visitorLoading: boolean;
  error: string | null;
  visitorAgreementUrl: string | null;
}

const initialState: VisitorsState = {
  visitorLoading: false,
  error: null,
  visitorAgreementUrl: null,
};

type VisitorsLoadingKey = 'visitorLoading';

const visitorsSlice = createSlice({
  name: 'visitorsData',
  initialState,
  reducers: {
    updateVisitor(
      state,
      _action: PayloadAction<{
        orgId: number;
        visitId: number;
        visitorId: number;
        visitorPayload: Partial<UpdateVisitorPayload>;
      }>,
    ) {
      state.error = null;
    },
    addVisitorsToVisit(
      state,
      _action: PayloadAction<{
        orgId: number;
        visitId: number;
        visitors: Visitor[];
      }>,
    ) {
      state.error = null;
    },
    removeVisitorFromVisit(
      state,
      _action: PayloadAction<{
        orgId: number;
        visitId: number;
        visitorId: number;
      }>,
    ) {
      state.error = null;
    },
    fetchVisitorAgreement(
      state,
      _action: PayloadAction<{
        orgId: number;
        visitId: number;
        visitorId: number;
      }>,
    ) {
      state.error = null;
    },

    setVisitorAgreementUrl(state, action: PayloadAction<string | null>) {
      state.visitorAgreementUrl = action.payload;
    },
    setLoading(
      state,
      action: PayloadAction<{ key: VisitorsLoadingKey; value: boolean }>,
    ) {
      state[action.payload.key] = action.payload.value;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },

    clearVisitorsState() {
      return initialState;
    },
  },
});

export const {
  updateVisitor,
  addVisitorsToVisit,
  removeVisitorFromVisit,
  fetchVisitorAgreement,
  setVisitorAgreementUrl,
  setLoading,
  setError,
  clearVisitorsState,
} = visitorsSlice.actions;

export const visitorsActions = visitorsSlice.actions;
export default visitorsSlice.reducer;
